import React from 'react';
import { Button, Form, Segment } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { FormGroup } from 'reactstrap';
import { fetchStudyType } from '../../Lookups/util';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class Filters extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: '',
            lastName: '',
            indexNumber: '',
            studyProgramId: '',
            studyProgramBasicId: '',
            studyTypes: [],
            studyTypeList: [],
            allStudyPrograms: [],
            studyPrograms: [],
            studyProgramBasics: []
        };
        this.onFilterData = this.onFilterData.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        let courseImplementationId = localStorage.getItem('courseImplementation');
        let obj = {};
        axios.get(`professor/study-program-basics-and-departments-by-course/${courseImplementationId}`, { ...obj })
            .then(SPBAndDepartmentsRes => {
                const studyProgramBasics = SPBAndDepartmentsRes.data.studyProgramBasics.map(el => ({
                    key: el.id,
                    value: el.id,
                    text: el.name
                }));
                this.setState({ studyProgramBasics });
            })
            .catch(err => {
                console.log('Failed to fetch study program basics');
            });

        axios.get(`professor/study-programs-by-course/${courseImplementationId}`, { ...obj })
            .then(res => {
                const allStudyPrograms = res.data.map(el => {
                    const fullName = `${el.studyProgramBasicName} | ${el.studyProgramName}`;

                    return {
                        key: el.studyProgramId,
                        value: el.studyProgramId,
                        text: fullName,
                        studyProgramBasicName: el.studyProgramBasicName,
                    };
                });

                this.setState({ allStudyPrograms });
            })
            .catch(err => {
                console.log('Failed to fetch study programs');
            });

        fetchStudyType()
            .then(studyTypeRes => {
                const studyTypes = studyTypeRes.data.map(el => ({
                    ...el,
                    key: el.id,
                    value: el.id,
                    text: el.displayName
                }));

                this.setState({ studyTypes });
            })
            .catch(err => {
                console.log('Failed to fetch study types');
            });
    }

    onFilterData() {
        if (!this.state.studyProgramId && !this.state.studyProgramBasicId &&
            this.state.studyTypeList.length === 0 && !this.state.indexNumber &&
            !this.state.firstName && !this.state.lastName) {
            toast('Morate unijeti po čemu želite filtrirati podatke!');
        } else {
            this.props.onFilterData(
                this.state.studyProgramBasicId,
                this.state.studyProgramId,
                this.state.studyTypeList,
                this.state.indexNumber,
                this.state.firstName,
                this.state.lastName
            );
        }
    }

    handleInputChange(event, { name, value }) {
        if (name === 'studyProgramBasicId') {
            const selectedBasic = this.state.studyProgramBasics.find(spb => spb.value === value);

            const studyPrograms = this.state.allStudyPrograms.filter(sp => sp.studyProgramBasicName === selectedBasic.text);

            this.setState({
                studyProgramBasicId: value,
                studyPrograms,
                studyProgramId: '' // reset studyProgram dropdown
            });

            return;
        }

        this.setState({
            [name]: value
        });
    }

    render() {
        return (
            <Segment clearing>
                <br />
                <br />
                <Form>

                    <Form.Group widths="equal">
                        <Form.Field>
                            <label>Smjer (studijski program)</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odaberite smjer (studijski program)"
                                value={this.state.studyProgramBasicId} // rename
                                onChange={this.handleInputChange}
                                name="studyProgramBasicId"
                                options={this.state.studyProgramBasics}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>

                        <Form.Field>
                            <label>Implementacija studijskog programa</label>
                            <Form.Dropdown
                                clearable
                                placeholder={
                                    this.state.studyProgramBasicId
                                        ? 'Odaberite implementaciju studijskog programa'
                                        : 'Najprije odaberite studijski program'}
                                value={this.state.studyProgramId}
                                onChange={this.handleInputChange}
                                name="studyProgramId"
                                options={this.state.studyPrograms}
                                search
                                fluid
                                selection
                                disabled={!this.state.studyProgramBasicId}
                            />
                        </Form.Field>
                    </Form.Group>

                    <FormGroup widths="equal">
                        <Form.Field>
                            <label>Tip studija</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odaberite jedan ili više tipova studija"
                                value={this.state.studyTypeList}
                                onChange={this.handleInputChange}
                                name="studyTypeList"
                                options={this.state.studyTypes}
                                search
                                fluid
                                selection
                                multiple
                            />
                        </Form.Field>

                        <Form.Field>
                            <label>Broj indexa</label>
                            <input
                                value={this.state.indexNumber}
                                onChange={(e) => this.setState({ indexNumber: e.target.value })}
                                name="indexNumber"
                                placeholder="Unesite broj indexa"
                            />
                        </Form.Field>
                    </FormGroup>

                    <Form.Group widths="equal">
                        <Form.Field>
                            <label>Ime</label>
                            <input
                                value={this.state.firstName}
                                onChange={(e) => this.setState({ firstName: e.target.value })}
                                name="firstName"
                                placeholder="Unesite ime"
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>Prezime</label>
                            <input
                                value={this.state.lastName}
                                onChange={(e) => this.setState({ lastName: e.target.value })}
                                name="lastName"
                                placeholder="Unesite prezime"
                            />
                        </Form.Field>
                    </Form.Group>
                    <Button color="blue" floated="right" onClick={this.onFilterData}>Filtriraj
                    </Button>
                    <Button basic="true" color="blue" floated="right" onClick={this.props.filtersOff}>Odustani
                    </Button>
                </Form>
                <ToastContainer hideProgressBar />

            </Segment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentGroups/Filters.js